import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=af6b0482&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=af6b0482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6b0482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af6b0482')) {
      api.createRecord('af6b0482', component.options)
    } else {
      api.reload('af6b0482', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=af6b0482&scoped=true&", function () {
      api.rerender('af6b0482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FyrwVAet4nt3/JS/teamMember.vue"
export default component.exports